// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider_slider_section__kKh8P {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  position: relative;
}

.slider_child_Section__EL4EQ {
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: var(--text-color);
  padding: 0.6rem;

  & h2 {
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & p {
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 500;
  }
}

.slider_btn__xn3L3 {
  display: flex;
  justify-content: end;
  align-items: center;

  & button {
    font-family: Inter;
    font-size: 0.8rem;
    font-weight: 600;
    border: none;
    padding: 19px 24px 19px 24px;
    text-align: center;
    background-color: var(--primary-color);
    color: var(--text-color);
    border-radius: 8px;
  }
}

.slider_cardSection__IfXdM {
  margin: 1rem 0 4rem;
  position: relative;

  & img {
    max-width: 100%;
    height: auto;
  }

  & p {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
    position: absolute;
    left: 0;
    padding: 10px;
    bottom: -16px;
    color: var(--text-color);
    font-family: Inter;
    font-size: 0.83rem;
    font-weight: 500;
  }
}

/* --------media-queries---------- */

@media screen and (max-width: 568px) {
  .slider_btn__xn3L3 {
    & button {
      width: 100%;
    }
  }

  .slider_cardSection__IfXdM {
    margin: 1rem 0;

    & p {
      width: 92%;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/SliderTo/slider.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,eAAe;;EAEf;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;;EAEnB;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,sCAAsC;IACtC,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iEAAiE;IACjE,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,aAAa;IACb,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,oCAAoC;;AAEpC;EACE;IACE;MACE,WAAW;IACb;EACF;;EAEA;IACE,cAAc;;IAEd;MACE,UAAU;IACZ;EACF;AACF","sourcesContent":[".slider_section {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: auto;\n  position: relative;\n}\n\n.child_Section {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n  color: var(--text-color);\n  padding: 0.6rem;\n\n  & h2 {\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & p {\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n}\n\n.btn {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n\n  & button {\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-weight: 600;\n    border: none;\n    padding: 19px 24px 19px 24px;\n    text-align: center;\n    background-color: var(--primary-color);\n    color: var(--text-color);\n    border-radius: 8px;\n  }\n}\n\n.cardSection {\n  margin: 1rem 0 4rem;\n  position: relative;\n\n  & img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  & p {\n    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n    position: absolute;\n    left: 0;\n    padding: 10px;\n    bottom: -16px;\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 0.83rem;\n    font-weight: 500;\n  }\n}\n\n/* --------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  .btn {\n    & button {\n      width: 100%;\n    }\n  }\n\n  .cardSection {\n    margin: 1rem 0;\n\n    & p {\n      width: 92%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider_section": `slider_slider_section__kKh8P`,
	"child_Section": `slider_child_Section__EL4EQ`,
	"btn": `slider_btn__xn3L3`,
	"cardSection": `slider_cardSection__IfXdM`
};
export default ___CSS_LOADER_EXPORT___;
